import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { CustomLabel } from 'component/reactSelect/CustomLabel'
import { components as SelectComponents } from 'react-select'

const ALL = 'all'

class CustomMultiValue extends Component {
  handleRemoveAll = () => {
    const newValue = []
    this.props.selectProps.onChange(newValue)
  }

  shouldMount = () => {
    const { data, selectProps } = this.props
    /* istanbul ignore else */
    if (data.value === selectProps.value[1].value) {
      /* istanbul ignore else */
      if (selectProps.value.some((option) => option.value === ALL)) {
        return (
          <CustomLabel
            option={{ label: selectProps.translate('option.all') }}
            handleRemove={() => this.handleRemoveAll()}
          />
        )
      }

      return (
        <CustomLabel
          option={{ label: selectProps.translate('customSelect.multiLabel') }}
          handleRemove={() => this.handleRemoveAll()}
        />
      )
    }
  }

  render() {
    const { children, selectProps } = this.props

    return (
      <div className='react-select__custom-container'>
        {selectProps.value.length <= 1 ? (
          <SelectComponents.MultiValueContainer {...this.props}>
            {children}
          </SelectComponents.MultiValueContainer>
        ) : (
          this.shouldMount()
        )}
      </div>
    )
  }
}

CustomMultiValue.propTypes = {
  selectProps: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  children: PropTypes.array,
}

export { CustomMultiValue }
